module.exports = __webpack_public_path__ + "static/no-credit-67029a7be18a170b0d2c2688dde64203.png";